import { BlackOrWhite } from './BlackOrWhite';

export function ColorPropertyObserver(elem) {
  // Get the lowercase name of the element.
  const elemName = elem.tagName.toLowerCase();
  // Define the callback.
  const callback = () => {
    const color = elem.color?.match?.(/\((.*?)\)/)?.[1] ?? elem.color;
    if (color) {
      const isVar = color.startsWith('--');
      const hexCode = isVar ? getComputedStyle(elem.parentKatapultElement ?? elem).getPropertyValue(color) : color;
      if (!hexCode) {
        setTimeout(callback, 1000);
      } else {
        const textColor = BlackOrWhite(hexCode, true);
        elem.style.setProperty(`--${elemName}-background-color`, isVar ? `var(${color})` : color);
        elem.style.setProperty(`--${elemName}-color`, textColor);
      }
    }
  };
  // Setup the color property observer.
  elem._createPropertyObserver('color', callback);
  // Call the callback once to initialize the color.
  callback();
}
